import "../assets/Text.css";
import { ref as j, computed as p, defineComponent as z, openBlock as S, createElementBlock as v, normalizeClass as te, unref as h, normalizeStyle as G, withModifiers as ne, createElementVNode as k, createCommentVNode as q, Fragment as D, createVNode as ae, renderList as re, createBlock as I, toDisplayString as ie, resolveDynamicComponent as se } from "vue";
import { p as R } from "./widgets-core.es.DdX21Kyh.js";
import { d as le } from "./debounce.BDLEW31m.js";
import { h as l, A as g, e as a, i as Y, g as b, L, D as x, j as ue, T as J } from "./maps.CbFe18_X.js";
import { q as de, e as F, i as pe, o as Q, s as ce, B as A } from "./useStore.CuiH5QIB.js";
function me(n) {
  return n && n.length ? n[0] : void 0;
}
const ye = {
  [l.ApplyPromoCode]: g.ApplyDiscount,
  [l.CloseTool]: g.NoAction,
  [l.EmailCapture]: g.SendSubscribe,
  emailCapture: g.SendSubscribe,
  [l.SendForm]: g.SendForm,
  [l.OpenUrl]: g.OpenUri,
  [l.CallPhoneNumber]: g.OpenUri,
  [l.OpenMailClient]: g.OpenUri,
  [l.SavedSearch]: g.SendSaveSearch,
  savedSearch: g.SendSaveSearch,
  [l.OpenBookingEngine]: g.OpenBookingEngine,
  [l.LastSearch]: g.OpenBookingEngine
};
function O(n) {
  return ye[n];
}
const N = de();
let W = 0;
function ge() {
  return W += 1, `extra-modules-${W}`;
}
function _(n) {
  const o = N.getLiteral(n), t = {
    [N.language]: o
  };
  return {
    sync: !0,
    id: ge(),
    mobile: t,
    desktop: t
  };
}
function H(n = "") {
  return {
    ..._(n),
    moduleType: a.Heading
  };
}
function E(n = "") {
  return {
    ..._(n),
    moduleType: a.Paragraph
  };
}
function w(n, o) {
  return {
    ..._(o),
    moduleType: a.Button,
    behaviour: {
      type: n
    }
  };
}
const he = {
  [a.EmailCapture]: "Your email address has been successfully added to our list.",
  [a.SavedSearch]: "We will send you an email with your search very soon.",
  [a.Form]: "We have received your form submission correctly"
}, $ = {
  [l.ApplyPromoCode]: "Apply promocode",
  [l.OpenUrl]: "Continue",
  [l.CloseTool]: "Close",
  [l.OpenBookingEngine]: "Book Now",
  [l.OpenMailClient]: "Contact Now",
  [l.CallPhoneNumber]: "Call Now"
}, U = j(), fe = [
  a.SavedSearch,
  a.EmailCapture,
  a.Form,
  a.Login
];
function Se(n) {
  var o;
  return ((o = n.find(
    (t) => fe.includes(t.moduleType)
  )) == null ? void 0 : o.moduleType) || "";
}
function K(n) {
  var o;
  return (o = n.find(
    (t) => t.moduleType === a.Button
  )) == null ? void 0 : o.behaviour.type;
}
function Te(n, o) {
  return n.filter((t) => {
    if (t.moduleType !== a.Button) return !1;
    const e = t;
    return e.kind === Y.Secondary && e.primaryButtonId === o;
  });
}
function be(n) {
  return n.reduce((o, t) => {
    var u;
    if (t.moduleType !== a.Button) return [...o, t];
    if (t.kind === Y.Secondary) return o;
    const y = Te(n, t.id);
    return [...o, {
      ...t,
      alignment: (u = me(y)) == null ? void 0 : u.alignment,
      secondaryButtons: y
    }];
  }, []);
}
function ze(n) {
  const o = be(n), t = {
    [b.Main]: o
  }, e = Se(o), y = o.find(
    (T) => T.moduleType === a.Login
  );
  if (!e) return t;
  if (y) {
    const T = o.find(
      (m) => m.moduleType === a.Button
    );
    if (t[b.Main] = o.reduce((m, d) => d.moduleType === a.Button ? m : d.moduleType === a.Login ? [
      ...m,
      {
        ...d,
        buttonModule: T,
        currentView: L.LoginRegister
      }
    ] : [...m, d], []), t[L.LoginSignin] = o.reduce((m, d) => d.moduleType !== a.Login ? m : d.moduleType === a.Login ? [
      ...m,
      {
        ...d,
        buttonModule: T,
        currentView: L.LoginSignin
      }
    ] : [...m, d], []), !e)
      return t;
    const P = K(o), M = $[P] || "Close";
    t[L.LoginSuccess] = o.reduce((m, d) => d.moduleType !== a.Login && d.moduleType !== a.Button ? m : d.moduleType === a.Button ? [
      ...m,
      {
        ...w(P, M)
      }
    ] : d.moduleType === a.Login ? [
      ...m,
      {
        ...d,
        currentView: L.LoginSuccess
      }
    ] : [...m, d], []);
    const Z = p(() => H("There has been an error.")), ee = p(() => E("Something went wrong. Please, try again later.")), oe = p(() => w(l.GoMainStep, "Back"));
    return t[b.Failure] = [
      Z.value,
      ee.value,
      oe.value
    ], t;
  }
  const r = K(o), u = $[r] || "Close", c = p(() => H("Thank you!")), s = p(() => E(
    he[e]
  )), i = p(
    () => w(r, u)
  ), f = p(() => H("There has been an error.")), B = p(() => E("Something went wrong. Please, try again later.")), C = p(() => w(l.GoMainStep, "Back"));
  return t[b.Success] = [
    c.value,
    s.value,
    i.value
  ], t[b.Failure] = [
    f.value,
    B.value,
    C.value
  ], K(o) === "submit" && (t[b.Success].pop(), t[b.Failure].pop()), t;
}
const ve = {
  fontSize: 16,
  lineHeight: 16,
  letterSpacing: 0
};
function X(n = ve, o = x.Desktop, t) {
  const {
    fontSize: e,
    lineHeight: y,
    letterSpacing: r
  } = n;
  let u;
  o === x.Desktop && t === ue.Compact ? u = 0.865 : o === x.Mobile && e > 12 ? u = 0.8 : u = 1;
  let c = Math.round(e * u);
  o === x.Mobile && e > 12 && c < 12 && (c = 12);
  const s = Math.round(y), i = (r ?? 0) / 100;
  return {
    fontSize: F(c),
    lineHeight: F(s),
    letterSpacing: r ? pe(i) : "normal"
  };
}
const ke = ["button-state", "moduleType", "data-module-id", "data-full-width", "aria-label", "aria-busy"], Pe = ["innerHTML"], Me = ["innerHTML"], Le = ["aria-label"], V = /* @__PURE__ */ z({
  __name: "Button",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    isLinkLayout: { type: Boolean },
    isSecondary: { type: Boolean },
    toolKind: {},
    layout: {}
  },
  emits: ["show-promo-code-fallback"],
  setup(n, { emit: o }) {
    const t = o, e = Q(), { t: y } = R(), r = n, u = p(() => {
      var i;
      return e == null ? void 0 : e.literals.getActiveModuleText(
        r.moduleProps,
        ((i = e == null ? void 0 : e.styles.fonts[r.moduleProps.moduleType]) == null ? void 0 : i.textTransform) === J.Titlecase,
        {
          candidates: e.extraData.dynamicTags,
          replacement: e.extraData.tokens
        }
      );
    }), c = p(
      () => {
        var i;
        return X(
          r.moduleProps.appearance,
          e == null ? void 0 : e.device,
          (i = r.layout) == null ? void 0 : i.size
        );
      }
    ), s = le(async () => {
      if ((e == null ? void 0 : e.handlers.buttonState) !== A.Sending)
        if (r.hasExtraSteps && !r.moduleProps.id.includes("extra"))
          U.value && (U.value.scrollTop = 0), e == null || e.handlers.callHandler(O(r.hasExtraSteps));
        else if (r.moduleProps.behaviour.type === l.GoMainStep)
          e == null || e.handlers.goBackToMainStep();
        else {
          const i = O(r.moduleProps.behaviour.type);
          !await (e == null ? void 0 : e.handlers.callHandler(i, r.moduleProps.id)) && r.moduleProps.behaviour.type === l.ApplyPromoCode && t("show-promo-code-fallback");
        }
    }, 200, { leading: !0, trailing: !1 });
    return (i, f) => {
      var B, C, T, P;
      return S(), v("button", {
        class: te([
          "thn--tool-button",
          {
            "inline-layout": i.isLinkLayout,
            "thn--tool-button__secondary": i.isSecondary,
            "bg-color": !i.isLinkLayout,
            "bg-color-secondary": !i.isLinkLayout && i.isSecondary
          }
        ]),
        "button-state": (B = h(e)) == null ? void 0 : B.handlers.buttonState,
        style: G(c.value),
        moduleType: i.moduleProps.moduleType,
        "data-module-id": i.moduleProps.id,
        "data-full-width": (C = i.moduleProps.appearance) == null ? void 0 : C.fullWidth,
        onMousedown: f[0] || (f[0] = ne(
          //@ts-ignore
          (...M) => h(s) && h(s)(...M),
          ["left"]
        )),
        onClick: f[1] || (f[1] = //@ts-ignore
        (...M) => h(s) && h(s)(...M)),
        "aria-label": u.value && h(ce)(u.value),
        "aria-busy": ((T = h(e)) == null ? void 0 : T.handlers.buttonState) === h(A).Sending ? "true" : "false"
      }, [
        i.isLinkLayout ? (S(), v("span", {
          key: 1,
          innerHTML: u.value
        }, null, 8, Me)) : (S(), v("span", {
          key: 0,
          class: "thn--tool-button__label",
          innerHTML: u.value
        }, null, 8, Pe)),
        ((P = h(e)) == null ? void 0 : P.handlers.buttonState) === h(A).Sending && !i.isLinkLayout ? (S(), v("div", {
          key: 2,
          class: "thn--tool-button__sending loader",
          "aria-label": h(y)("Sending"),
          "aria-live": "polite"
        }, f[2] || (f[2] = [
          k("div", { class: "la-ball-pulse" }, [
            k("div", { "aria-hidden": "true" }),
            k("div", { "aria-hidden": "true" }),
            k("div", { "aria-hidden": "true" })
          ], -1)
        ]), 8, Le)) : q("", !0)
      ], 46, ke);
    };
  }
}), Be = ["data-button-alignment"], Ce = {
  key: 0,
  class: "thn--tool-cta-group-promo-code-fallback text-sm"
}, _e = /* @__PURE__ */ z({
  __name: "CTAGroup",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const o = n, { t } = R(), e = j(!1);
    return (y, r) => {
      var u;
      return S(), v(D, null, [
        k("div", {
          class: "thn--tool-cta-group",
          "data-button-alignment": o.moduleProps.alignment ?? "horizontal"
        }, [
          ae(V, {
            "has-extra-steps": o.hasExtraSteps,
            "tool-kind": o.toolKind,
            layout: o.layout,
            "is-link-layout": ((u = o.moduleProps.appearance) == null ? void 0 : u.layout) === "link",
            "module-props": o.moduleProps,
            onShowPromoCodeFallback: r[0] || (r[0] = (c) => {
              e.value = !0;
            })
          }, null, 8, ["has-extra-steps", "tool-kind", "layout", "is-link-layout", "module-props"]),
          (S(!0), v(D, null, re(y.moduleProps.secondaryButtons, (c) => {
            var s;
            return S(), I(V, {
              key: c.id,
              "has-extra-steps": o.hasExtraSteps,
              "tool-kind": o.toolKind,
              "is-link-layout": ((s = c.appearance) == null ? void 0 : s.layout) === "link",
              "is-secondary": !0,
              layout: o.layout,
              "module-props": c,
              onShowPromoCodeFallback: r[1] || (r[1] = (i) => e.value = !0)
            }, null, 8, ["has-extra-steps", "tool-kind", "is-link-layout", "layout", "module-props"]);
          }), 128))
        ], 8, Be),
        e.value ? (S(), v("div", Ce, [
          k("p", null, " ℹ️ " + ie(h(t)("Use the promocode {behaviour} when making your reservation to enjoy your discount.", { behaviour: o.moduleProps.behaviour.value })), 1)
        ])) : q("", !0)
      ], 64);
    };
  }
}), De = /* @__PURE__ */ z({
  __name: "Text",
  props: {
    moduleProps: {},
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const o = {
      [a.Heading]: {
        fontSize: 24,
        lineHeight: 24
      },
      [a.Paragraph]: {
        fontSize: 16,
        lineHeight: 16
      },
      [a.Button]: {
        fontSize: 18,
        lineHeight: 18
      }
    }, t = Q(), e = n, y = p(() => {
      var s;
      return t == null ? void 0 : t.literals.getActiveModuleText(
        e.moduleProps,
        ((s = t == null ? void 0 : t.styles.fonts[e.moduleProps.moduleType]) == null ? void 0 : s.textTransform) === J.Titlecase,
        {
          candidates: t.extraData.dynamicTags,
          replacement: t.extraData.tokens
        }
      );
    }), r = p(
      () => e.moduleProps.appearance || o[e.moduleProps.moduleType]
    ), u = p(
      () => {
        var s;
        return X(r.value, t == null ? void 0 : t.device, (s = e.layout) == null ? void 0 : s.size);
      }
    ), c = p(() => e.moduleProps.moduleType === "heading" ? "h2" : e.moduleProps.moduleType === "paragraph" ? "p" : "div");
    return (s, i) => (S(), I(se(c.value), {
      class: "thn--tool-text",
      style: G(u.value),
      innerHTML: y.value,
      "module-type": s.moduleProps.moduleType,
      "data-module-id": s.moduleProps.id,
      tabindex: "-1"
    }, null, 8, ["style", "innerHTML", "module-type", "data-module-id"]));
  }
});
export {
  De as _,
  X as a,
  _e as b,
  be as c,
  O as g,
  Se as h,
  U as s,
  ze as u
};
//# sourceMappingURL=Text.vue_vue_type_style_index_0_lang.CGXfDawb.js.map
